import React from "react"

const CSS = `
@keyframes pp-pop { 0% { transform: scale(.96); opacity: .4 } 60% { transform: scale(1.02); opacity: 1 } 100% { transform: scale(1) } }
@keyframes pp-rise { from { transform: translateY(8px); opacity: 0 } to { transform: none; opacity: 1 } }
@keyframes pp-pulse { 0%, 100% { opacity: .55 } 50% { opacity: .9 } }
@keyframes pp-bar { 0% { transform: translateX(-100%) } 100% { transform: translateX(250%) } }
.pp-chip { animation: pp-pop .22s ease-out both }
.pp-chip.pp-pending { animation: pp-pulse 1.1s ease-in-out infinite }
.pp-toast { animation: pp-rise .2s ease-out both }
.pp-float { animation: pp-rise .16s ease-out both }
.pp-loading-bar { animation: pp-bar 1.1s ease-in-out infinite }
.pp-hatch { background-image: repeating-linear-gradient(135deg, rgba(148, 163, 184, .22) 0 5px, transparent 5px 11px) }
.pp-dragging .pp-drop:not(.pp-blocked) { box-shadow: inset 0 0 0 1px rgba(77, 158, 236, .18) }
.pp-dragging .pp-drop-hint { opacity: 1 }
.pp-over { animation: pp-pop .18s ease-out both }
`

const Styles = () => <style>{CSS}</style>

export default Styles
